import { useSearchParams } from 'react-router-dom'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function AuthError() {
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error')

  return (
    <div className="container flex items-center justify-center min-h-screen">
      <Card className="w-[400px]">
        <CardHeader>
          <CardTitle>Erreur d'authentification</CardTitle>
          <CardDescription>Une erreur s'est produite lors de l'authentification</CardDescription>
        </CardHeader>
        <CardContent>
          <Alert variant="destructive">
            <AlertTitle>Erreur</AlertTitle>
            <AlertDescription>{error || "Une erreur inconnue s'est produite"}</AlertDescription>
          </Alert>
        </CardContent>
      </Card>
    </div>
  )
} 